import PropTypes from 'prop-types';
import classNames from 'classnames';
import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles'
import { injectIntl } from 'react-intl';
import { withRtl } from '../hoc';
import CaretDownIcon from '../icons/CaretDown';
import style from './Select.scss';

class Select extends Component {
  static propTypes = {
    selectKey: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    onSelectionChange: PropTypes.func.isRequired,
    selected: PropTypes.string.isRequired,
    // intl: PropTypes.shape({
    //   locale: PropTypes.string,
    //   messages: PropTypes.shape({}),
    // }).isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      open: false,
      selected: this.props.selected,
      options: [...this.props.options],
    };
  }

  selectOption = (id, value) => {
    const { selectKey } = this.props;
    this.setState({ ...this.state, selected: value, open: false });
    this.props.onSelectionChange(selectKey, id, value);
  };

  toggle = () => {
    this.setState({ ...this.state, open: !this.state.open });
  };

  render() {
    const { options, selectKey } = this.props;
    const { open, selected } = this.state;
    const buttonClass = classNames(
      style.button,
      { [style.buttonOpen]: open },
      { [style.buttonHighlighted]: !selected },
    );

    return (
      <div className={style.root}>
        <button className={buttonClass} onClick={this.toggle} aria-expanded={this.state.open}>
          {selected}
          <CaretDownIcon size={10} fill="#0345a7" />
        </button>
        {open && (
          <div className={style.dropDown}>
            <div className={style.wrap}>
              {options.map(option => (
                <div
                  className={style.item}
                  id={option.id}
                  value={option.name}
                  key={`${selectKey}-${option.id}`}
                  onClick={() => this.selectOption(option.id, option.name)}
                  aria-label={option.name}
                >
                  {option.name}
                </div>
              ))}
            </div>
          </div>
        )}
        {open && <div role="presentation" className={style.modalBackground} onClick={this.toggle} />}
      </div>
    );
  }
}

export { Select };
export default withRtl(style)(withStyles(style)(injectIntl(Select)));
